import { render } from "./SidenavItemTwo.vue?vue&type=template&id=5d7969f4&scoped=true"
import script from "./SidenavItemTwo.vue?vue&type=script&lang=js"
export * from "./SidenavItemTwo.vue?vue&type=script&lang=js"

import "./SidenavItemTwo.vue?vue&type=style&index=0&id=5d7969f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7969f4"]])

export default __exports__